const actionEl = document.querySelector( '[data-target="reward-actions"]' );
const actions = actionEl ? parseInt( actionEl.value ) : 0;
let completed = 0;

class RewardBlock {
	constructor() {
		this.twitter = document.querySelectorAll(
			'[data-action="twitterFollow"]'
		);
		this.tweet = document.querySelectorAll( '[data-action="sendTweet"]' );
		this.youtube = document.querySelectorAll(
			'[data-action="youtubeSubscribe"]'
		);

		this.listeners();
	}

	listeners() {
		this.twitter.forEach( ( el ) =>
			el.addEventListener( 'click', this.twitterFollow )
		);
		this.tweet.forEach( ( el ) =>
			el.addEventListener( 'click', this.sendTweet )
		);
		this.youtube.forEach( ( el ) =>
			el.addEventListener( 'click', this.youtubeSubscribe )
		);
	}

	twitterFollow( e ) {
		if ( e.currentTarget.classList.contains( 'clicked' ) ) {
			return;
		}

		let account = e.currentTarget.dataset.account;
		window.open(
			'https://twitter.com/intent/follow?screen_name=' + account,
			'_blank'
		);
		document
			.querySelector( '[data-target="twitterCompleted"]' )
			.classList.remove( 'hidden' );
		completed++;

		RewardBlock.checkStatus( e.currentTarget );
	}

	sendTweet( e ) {
		if ( e.currentTarget.classList.contains( 'clicked' ) ) {
			return;
		}

		let message = document.querySelector( '[data-target="tweet-message"]' )
			.innerHTML;
		let url = document.querySelector( '[data-target="tweet-url"]' ).value;

		window.open(
			'https://twitter.com/intent/tweet?text=' +
				encodeURIComponent( message ) +
				'&url=' +
				encodeURI( url ),
			'_blank'
		);
		document
			.querySelector( '[data-target="tweetCompleted"]' )
			.classList.remove( 'hidden' );
		completed++;

		RewardBlock.checkStatus( e.currentTarget );
	}

	youtubeSubscribe( e ) {
		if ( e.currentTarget.classList.contains( 'clicked' ) ) {
			return;
		}

		let url = e.currentTarget.dataset.url;
		window.open( url + '?sub_confirmation=1', '_blank' );
		document
			.querySelector( '[data-target="youtubeCompleted"]' )
			.classList.remove( 'hidden' );
		completed++;

		RewardBlock.checkStatus( e.currentTarget );
	}

	static checkStatus( target ) {
		target.classList.add( 'clicked' );

		if ( completed == actions ) {
			document
				.querySelector( '[data-target="download"]' )
				.classList.remove( 'hidden' );
		}
	}
}

export default RewardBlock;
